<template>
  <div>
    <el-row style="margin-top: 12px;align-items: flex-start;">
      <el-col :span="2" style="display: flex;">
        <img :src="require('@/assets/render/icons8_picture.svg')" style="width: 80%">
      </el-col>
      <el-col :span="10" class="propsLeft">{{ label }}</el-col>
      <el-col :span="12" class="propsRight">
        <el-switch v-model="innerVisible" @change="changeVisible"></el-switch>
      </el-col>
    </el-row>
    <el-row style="margin: 12px 0;align-items: flex-start;">
      <template v-if="$store.state.ui.os.isPC">
        <el-col :span="12" class="propsLeft" style="color: #c4c4c4;">
          <p v-html="labelSize" style="padding: 0;margin: 0;font-size: small;"></p>
        </el-col>
        <el-col :span="12" class="propsRight">
          <el-button size="small" round @click="showProcesser">
            定制
          </el-button>
        </el-col>
      </template>
      <template v-else>
        <el-col :span="12" class="propsLeft" style="color: #c4c4c4;">
          <p v-html="labelSize" style="padding: 0;margin: 0;font-size: small;"></p>
        </el-col>
        <el-col :span="12">
          <el-row class="propsRight" style="justify-content: right;">
            <el-button size="small" round @click="showProcesser">
              定制
            </el-button>
          </el-row>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    size: {
      type: Object,
      required: true
    },
    processer: {
      type: Boolean,
      default: false
    },
    blendMode: {
      type: String
    },
    mask: {
      type: String
    },
    sizeNote: {
      type: String
    }
  },
  data () {
    return {
      innerVisible: false
    }
  },
  computed: {
    labelSize () {
      if (this.sizeNote) {
        return this.sizeNote.replaceAll('\t', '').replaceAll('\n', '<br>')
      } else {
        return `${this.size.width}x${this.size.height}`
      }
    }
  },
  methods: {
    changeVisible () {
      this.$emit('change', {
        id: this.id,
        valueProp: 'visible',
        value: this.innerVisible
      })
    },
    showProcesser () {
      this.$emit('change', {
        id: this.id,
        valueProp: 'processer',
        value: true
      })
    },
    onCrop (data) {
      this.$emit('change', {
        id: this.id,
        valueProp: 'src',
        value: data.src,
        crop: data.crop,
        name: data.name
      })
    },
    changeBlendMode (val) {
      this.$emit('change', {
        id: this.id,
        valueProp: 'blendMode',
        value: val
      })
    }
  },
  watch: {
    visible (val) {
      this.innerVisible = val
    }
  },
  mounted () {
    this.innerVisible = this.visible
  }
}
</script>
